import React, { useEffect, useRef, useState } from 'react';
import { observer, inject } from 'mobx-react';
import { IInjectedProps } from '../../../../types';
import { SizeValue } from './sizeValue/sizeValue';
import styles from './sizeValues.scss';
import { ISalesArticleVariantSize } from '../../../../stores/types';
import { CustomSwiper } from '../customeSwiper/customeSwiper';
import SwiperCore from 'swiper';

export const SizeValues = inject('store')(
    observer(({ store }: IInjectedProps) => {
        const availableSizes = store.variantStore.selectedSizeType?.sizes;
        const slidesPerColumn =
            store.getIsMobileView || availableSizes.length <= store.variantStore.defaultColumnsPerView ? 1 : 2;
        const tmpSelectedSizeIndex = availableSizes?.findIndex((size) => {
            return size.size.code === store.variantStore.selectedSize?.size.code;
        });
        const selectedSizeIndex = tmpSelectedSizeIndex ? tmpSelectedSizeIndex : 0;
        const wrapperRef = useRef<HTMLDivElement>(null);
        const [column, setColumn] = useState(1);
        const [maxWidth, setMaxWidth] = useState(
            [{selectedSizeTypeName: store.variantStore.selectedSizeType?.sizeTypeName, 
            width: 42}]);

        useEffect(() => {
            if (wrapperRef.current) {
                store.setGroupElement(wrapperRef.current);
            }
        }, []);

        useEffect(() => {
            calculateWidth();
        }, [store.variantStore?.selectedSizeType.sizeTypeName]);

        function calculateWidth() {
            const sizeValueWidth = maxWidth.find((item) => item.selectedSizeTypeName === 
            store.variantStore.selectedSizeType?.sizeTypeName)?.width;

            let tempColumn = store.variantStore.defaultColumnsPerView;

            tempColumn = Math.floor((wrapperRef.current.clientWidth - 70) / (sizeValueWidth + 10));
            if (tempColumn > 5) 
                tempColumn = store.variantStore.defaultColumnsPerView;

            setColumn(tempColumn);
        }

        function renderArticleVariantSize(articleVariantSize: ISalesArticleVariantSize, 
            selectedSizeTypeName: string) {
            const tmpValue = maxWidth.find((item) => item.selectedSizeTypeName === 
            store.variantStore.selectedSizeType?.sizeTypeName)?.width;

            return (
                <SizeValue
                    size={articleVariantSize.size}
                    variantKey={articleVariantSize.salesArticleVariantKey}
                    key={articleVariantSize.size.name}
                    maxWidth={tmpValue}
                    changeMaxWidth={changeMaxWidth}
                    selectedSizeTypeName={selectedSizeTypeName}
                />
            );
        }

        const startSwipeCallBack = () => {
            store.variantStore.changeVisibleFitAccuracyPointer(false);
        };

        const endSwipeCallBack = (swiper: SwiperCore) => {
            store.variantStore.changeVisibleFitAccuracyPointer(true);
            store.variantStore.changeOffSetSizeIndex(swiper.realIndex);
        };

        function changeMaxWidth(value: number, selectedSizeTypeName) {
            const index = maxWidth.findIndex((item) => item.selectedSizeTypeName === selectedSizeTypeName);

            if (index > -1) {
                maxWidth[index].width = value;
            } else {
                maxWidth.push({selectedSizeTypeName, width: value});
            }

            setMaxWidth(maxWidth);
        }

        return (
            <div data-testid='size_values' className={styles.size_values} ref={wrapperRef}>
                <CustomSwiper
                    type='size'
                    selectedElementIndex={selectedSizeIndex}
                    slidesPerColumn={slidesPerColumn}
                    columnsPerView={column}
                    enabled={true}
                    startSwipeCallBack={startSwipeCallBack}
                    endSwipeCallBack={endSwipeCallBack}
                    swipingEnabled={true}
                    setTabNavFocusable={store.setFocusableElement}
                >
                    {availableSizes.map((size) => renderArticleVariantSize(
                        size, store.variantStore.selectedSizeType?.sizeTypeName))}
                </CustomSwiper>
            </div>
        );
    })
);
